"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyServiceIdentifier = void 0;
const LazyServiceIdentifier_1 = require("./services/models/LazyServiceIdentifier");
Object.defineProperty(exports, "LazyServiceIdentifier", { enumerable: true, get: function () { return LazyServiceIdentifier_1.LazyServiceIdentifier; } });
//# sourceMappingURL=index.js.map